<template>
  <div class="field form-item" :class="field.classes != null ? field.type+' '+field.classes : field.type" v-if="field.show && hide != true">
    <div v-if="field.type == 'toggle'">
      <input type="checkbox" v-model="field.value" @change="updateFields" :required="('required' in field && field.required == true) ? true : false" />
    </div>

    <label v-if="field.name != ''">{{ field.name }}<span v-if="field.required">*</span></label>

    <input type="text" @change="updateFields" v-model="field.value" v-if="field.type == 'text' || field.type == 'encrypted'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false" :placeholder="field.placeholder" />

    <input type="number" @change="updateFields" v-model="field.value" v-if="field.type == 'number' && field.slug != 'amount'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false" :placeholder="field.placeholder" :min="field.min" :max="field.max" />

    <input type="number" @change="updateFields" v-model="field.value" v-if="field.type == 'number' && field.slug == 'amount'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false" :placeholder="field.placeholder" :min="field.min" :max="field.max" step="0.01" />

    <input type="text" v-mask="'##/##/####'" v-model="field.value" v-if="field.type == 'date'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false" :placeholder="field.placeholder" />

    <input type="email" @change="updateFields" v-model="field.value" v-if="field.type == 'email'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false" />

    <datepicker v-model="field.value" :initial-view="(field.initialView != null) ? field.initialView : 'year'" :typeable="true" :format="(field.format != null) ? field.format : 'MM/dd/yyyy'" v-if="field.type == 'datepicker'" :key="field.slug" :required="('required' in field && field.required == true) ? true : false"></datepicker>

    <select v-model="field.value" @change="updateFields" v-if="field.type == 'select'" :required="('required' in field && field.required == true) ? true : false">
      <option value=""></option>
      <option :value="option.value" v-for="option in field.options" v-bind:key="option.value">{{ option.name }}</option>
    </select>

    <select v-model="field.value" @change="updateFields" v-if="field.type == 'dynamic-select'" :required="('required' in field && field.required == true) ? true : false">
      <option value="Not Sure">Not Sure</option>
      <option :value="option.value" v-for="option in field.options" v-bind:key="option.value">{{ option.name }}</option>
    </select>

    <textarea v-model="field.value" @change="updateFields" v-if="field.type == 'textarea'" :required="('required' in field && field.required == true) ? true : false"></textarea>

    <div class="" v-if="field.type == 'radio'">
      <div class="radio" v-for="option in field.options" v-bind:key="option">
        <input type="radio" :value="option" v-model="field.value" @change="updateFields" /> <span>{{ option }}</span>
      </div>
    </div>   

    <div v-if="field.type == 'repeater'">
      <div class="repeater d-flex flex-column flex-lg-row px-0" v-for="subFields in field.subFields" v-bind:key="subFields">
        <div class="sub-field form-item third" v-for="subField in subFields" v-bind:key="subField">
          <label v-if="subField.name != ''">{{ subField.name }}<span v-if="subField.required">*</span></label>
          <input type="text" v-model="subField.value" v-if="subField.type == 'text' || subField.type == 'encrypted'" :key="subField.slug" :required="('required' in subField && subField.required == true) ? true : false" :placeholder="subField.placeholder" />
          <datepicker v-model="subField.value" initial-view="year" format="MM/dd/yyyy" :typeable="true" v-if="subField.type == 'datepicker'" :required="('required' in field && field.required == true) ? true : false"></datepicker>
        </div>
      </div>
      <a class="button" @click="addRepeater(field)">Add Another</a>
    </div>

    <div v-if="field.type == 'numeric-repeater'">
      <div class="repeater d-flex flex-column flex-lg-row px-0" v-for="subFields in field.subFields" v-bind:key="subFields">
        <div class="sub-field form-item third" v-for="subField in subFields" v-bind:key="subField">
          <label v-if="subField.name != ''">{{ subField.name }}<span v-if="subField.required">*</span></label>
          <input type="text" v-model="subField.value" v-if="subField.type == 'text' || subField.type == 'encrypted'" :key="subField.slug" :required="('required' in subField && subField.required == true) ? true : false" :placeholder="subField.placeholder" />
          <datepicker v-model="subField.value" :initial-view="(subField.initialYear != null) ? subField.initialyear : 'year'" format="MM/dd/yyyy" :typeable="true" v-if="subField.type == 'datepicker'" :required="('required' in field && field.required == true) ? true : false"></datepicker>
        </div>
      </div>
    </div>

    <div class="description mt-1 font-italic text-0" v-if="'description' in field" v-html="field.description"></div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Api from '@/Api.js'

export default {
  name: 'Field',
  components: {
    Datepicker
  },
  data() {
    return {
      hide: false
    };
  },
  props: [
    'field',
    'fields'
  ],
  methods: {
    addRepeater(field) {
      field.subFields.push(JSON.parse(JSON.stringify(field.subFieldTemplate)));
    },
    removeRepeater(subFieldIndex) {
      this.field.subFields.splice(subFieldIndex, 1);
    },
    updateFields() {
      this.updateConditions();
      this.updateRepeaters();
    },
    updateConditions() {
      this.$parent.fields.every(field => {
        if (field.conditions == null) {
          field.show = true;
          return true;
        }
        let result = true;
        field.conditions.every(condition => {
          let dependentField = this.fields.filter((field) => field.slug == condition.field);
          if (dependentField.length > 0) dependentField = dependentField[0];
          if (condition.operator == '==') {
            if (condition.values.includes(dependentField.value)) {
              result = true;
            } else {
              result = false;
              return false;
            }
          }
          if (condition.operator == '!=') {
            if (!condition.values.includes(dependentField.value)) {
              result = true;
            } else {
              result = false;
              return false;
            }
          }
          return true;
        });
        field.show = result;
        return true;
      });
    },
    updateRepeaters() {
      this.$parent.fields.forEach(field => {
        if (field.type == 'numeric-repeater') {
          let numberField = this.fields.find(field2 => field2.slug == field.numberField);
          if (field.subFields.length == numberField.value) return false;
          field.subFields = [];
          for (let i=1; i <= parseInt(numberField.value); i++) {
            let newArray = JSON.parse(JSON.stringify(field.subFieldTemplate));
            field.subFields.push(newArray);
          }
        }
      });
    }
  },
  mounted() {
    this.updateFields();
    if (this.field.type == 'dynamic-select') {
      Api.get(this.field.dataUrl).then(response => {
        let options = [];
        for (var key of Object.keys(response.data)) {
          options.push({ name: response.data[key].name, value: response.data[key].value });
        }
        this.field.options = options;
      });
    }

    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    for (let param of params.entries()) {
      //console.log(this.field.slug + ' = ' + param[0]);
      if (this.field.slug == param[0]) {
        console.log('matched: ' + param[0] + ' and '+param[1]);
        if (param[1] == 'hide') {
          console.log('hiding');
          this.hide = true;
          this.show = false;
        } else {
          this.field.value = param[1];
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>